/* eslint-disable no-unused-vars */
import { observeElement } from '@uvocore-front/utils';
import { addActiveLinkClass } from '../../../utils';
import '../../../components/Header/js/Header';
import '../../../components/Calculator/Calculator';
import Carousel from '../../../components/CustomCarousel';
import Accordion from '../../../components/Accordion/Accordion';

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Call slider for Steps
   */
  observeElement({ /* eslint-disable-line */
    element: '.features',
    marginValue: 200,
    callback: () => {
      // eslint-disable-next-line no-new
      new Carousel({
        selector: document.querySelector('.features'),
        itemWidth: 245,
        margin: 40,
        responsive: {
          768: {
            inactive: true,
          },
        },
      });
    },
  });

  addActiveLinkClass({
    anchorSelector: '.services__list a',
  });

  observeElement({
    element: '.faq-list',
    marginValue: 400,
    callback: Accordion({
      container: document.querySelector('.Faq'),
      headingSelector: '.Faq__heading',
      contentSelector: '.Faq__content',
      itemsSelector: '.Faq',
      contentWrapperSelector: '.Faq__body',
    }),
  });
});
